module.exports = __webpack_public_path__ + "static/media/home_healthcare_document_icon.021f5907.png";